/// <amd-module name="Dashboards/WidgetHost/MessageComponents/DefaultWidgetFailedMessage" />
import React = require("react");
import { VssComponent } from "VSS/Platform/Layout";

export interface DefaultWidgetFailedMessageProps {
    errorText: string;
}

/** Detail View for Widgets which seem to be uninstalled or otherwise unavailable from EMS. */
export class DefaultWidgetFailedMessage extends VssComponent<DefaultWidgetFailedMessageProps> {
    public render(): JSX.Element {
        return <div className={"widget-failed-dialog-content"}>{this.props.errorText}</div>;
    }
}
